import { Attribution, StatsType } from 'types'

interface Params {
  endDate: string
  startDate: string
  attr: Attribution
  eventType: StatsType
}

export const getTopPages = ({
  endDate,
  startDate,
  attr,
  eventType,
}: Params) => {
  const statsFields = new Set(['views', 'new_visitors'])
  const where = `WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`

  if (statsFields.has(eventType)) {
    return `SELECT page.page_id, page.href, SUM(stats.${eventType}) FROM page ${where} GROUP BY page.page_id, page.href ORDER BY SUM(stats.${eventType}) DESC LIMIT 6 OFFSET 0`
  }

  const attrPrefix = attr === 'linear' || attr === 'ai' ? `${attr}_page` : attr
  const fetchType  = `${attrPrefix}.${eventType}`

  return `SELECT page.page_id, page.href, SUM(${fetchType}) FROM page ${where} GROUP BY page.page_id, page.href ORDER BY SUM(${fetchType}) DESC LIMIT 6 OFFSET 0`
}
